var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.414,
    height: 15.525,
    viewBox: "0 0 14.414 15.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2944",
    "data-name": "Grupo 2944",
    transform: "translate(-129.5 -982.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "share",
    d: "M13.621,11.955A2.769,2.769,0,0,0,11.467,13L7.418,10.471a2.469,2.469,0,0,0,0-1.462l4.049-2.531a2.769,2.769,0,1,0-.615-1.722,2.656,2.656,0,0,0,.111.731L6.914,8.017a2.769,2.769,0,1,0,0,3.445l4.049,2.531a2.656,2.656,0,0,0-.111.731,2.769,2.769,0,1,0,2.769-2.769Zm0-8.861a1.662,1.662,0,1,1-1.175.487,1.662,1.662,0,0,1,1.175-.487ZM4.76,11.4a1.661,1.661,0,1,1,1.175-.487A1.661,1.661,0,0,1,4.76,11.4Zm8.861,4.985A1.661,1.661,0,1,1,14.8,15.9a1.661,1.661,0,0,1-1.175.487Z",
    transform: "translate(127.523 980.184)",
    fill: "#b895ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.4826b47ec2471ba402586a720a066843.svg";
export { ForwardRef as ReactComponent };